/**
 * Portal Manta · agComparador
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { PER_EXTRACTED } from '../../data/per-extracted.js';

function agComparador(ctx, prev){
  const {lote, sig, cf, od, ext} = ctx;
  const perKey = 'L'+sig;
  const perData = PER_EXTRACTED[perKey];
  if(!perData){
    return {
      sub:'Comparador PER × MEF',
      status:'pendente',
      msg:`PER do Lote ${sig} ainda não foi processado pelo agente leitor. Resultado disponível só para L4 e L5.`,
      inconsistencias:[]
    };
  }
  const inc = [];
  const extPER = perData.lote?.extensao_km;
  const extDif = ext - (extPER||0);
  if(extPER && Math.abs(extDif)>1){
    inc.push({severidade:'media',campo:'extensao',valor_v9:ext,valor_per:extPER,diff:extDif});
  }
  const rodsV9 = (od.sistema||[]).length;
  const rodsPER = (perData.rodovias||[]).length;
  if(rodsV9 !== rodsPER){
    inc.push({severidade:'baixa',campo:'n_rodovias',valor_v9:rodsV9,valor_per:rodsPER,diff:rodsV9-rodsPER,
      nota:'Diferença pode ser por modelagem (contornos como rodovia separada vs englobada)'});
  }
  const sumExtV9 = (od.sistema||[]).reduce((s,r)=>s+(r.ext||0),0);
  const sumExtPER = (perData.rodovias||[]).reduce((s,r)=>s+(r.ext_km||0),0);
  if(Math.abs(sumExtV9-sumExtPER)>5){
    inc.push({severidade:'media',campo:'soma_extensoes',valor_v9:sumExtV9,valor_per:sumExtPER,diff:sumExtV9-sumExtPER});
  }
  if(sig==='4' && perData.rodovias_detalhe){
    const dupPER = perData.rodovias_detalhe.reduce((s,r)=>s+(r.duplicacao_km||0),0);
    const dupV9 = ((od.duplicacoes||[]).reduce((s,r)=>s+(r.km||0),0)) + ((od.contornos||[]).reduce((s,r)=>s+(r.km||0),0));
    if(Math.abs(dupV9-dupPER)>5){
      inc.push({severidade:'media',campo:'duplicacao_total_km',valor_v9:dupV9.toFixed(1),valor_per:dupPER.toFixed(1),diff:(dupV9-dupPER).toFixed(1)});
    }
  }
  return {
    sub:'Comparador PER × MEF',
    status: inc.length===0?'ok':(inc.some(i=>i.severidade==='alta')?'critico':'atencao'),
    msg:`${inc.length} inconsistências encontradas`,
    inconsistencias:inc,
    perKey,
    cobertura: perKey in PER_EXTRACTED ? 'L4/L5 disponíveis · L3 pendente de leitura' : 'pendente'
  };
}

export { agComparador };
export default agComparador;
